export default {
  verboseName: "Strumento",
  verboseNamePlural: "Strumenti",
  modelName: "Instrument",
  modelNamePlural: "Instruments",
  appName: "instruments",
  propName: "instrument",
  propNamePlural: "instruments",
}
